import { isRouteErrorResponse, useRouteError } from 'react-router'

import { ErrorBoundaryContent } from 'components/error-boundary/ErrorBoundaryContent'
import { NotFound } from 'features/not-found'

export const RouteErrorBoundary = (): JSX.Element => {
  const error = useRouteError()

  if (isRouteErrorResponse(error) && error.status === 404) {
    return <NotFound />
  }

  return (
    <div
      data-testid="route-error-boundary"
      style={{ height: '100%', width: '100%' }}
    >
      <ErrorBoundaryContent />
    </div>
  )
}
